import React, { useEffect } from "react";
import "./Previous.css";
import CardLogo from "./images/card-logo.png";
import unicef from "./images/UNICEF.jpeg";
import cry from "./images/cry.png";
import moef from "./images/moef1.jfif";
import rangde from "./images/rangde.png";
import gyws from "./images/gyws.jfif";
import AOS from "aos";

function PreviousAssociationTrying() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div className="PrevAssocP">
      <div className="PrevAssocNameName" data-aos="fade-left">
        <h1>OUR ASSOCIATIONS</h1>
      </div>
      <div className="PrevAssocCont">
        <div className="PrevAssocCardd" id="cr1">
          <img src={unicef} alt="" />
          <div className="PrevAssocNameTitle">UNICEF</div>
        </div>
        <div className="PrevAssocCardd">
          <img src={rangde} alt="" />
          <div className="PrevAssocNameTitle">Rang De</div>
        </div>
        <div className="PrevAssocCardd" id="cry">
          <img src={cry} alt="" />
          <div className="PrevAssocNameTitle">CRY</div>
        </div>
        <div className="PrevAssocCardd" id="gyws">
          <img src={gyws} alt="" />
          <div className="PrevAssocNameTitle">GYWS</div>
        </div>
        <div className="PrevAssocCardd" id="moef">
          <img src={moef} alt=""/>
          <div className="PrevAssocNameTitle">Ministry Of Forests and Environment</div>
        </div>
      </div>
      <hr className='hr-tag'/>
    </div>
  );
}

export default PreviousAssociationTrying;
